import { func, number, shape, string } from 'prop-types';
import React from 'react';

import { campaignShape } from '../../prop-types';
import TargetKpi from '../../quote-editor/utils/TargetKpi';
import getTarget from './util';

function ChangeTargetForm({ campaign, value, onChange }) {
  const { targetKpi, targetKpiValue } = getTarget(campaign);
  const { campaignObjective } = campaign.quote;
  return (
    <>
      <span> Current </span>
      <TargetKpi
        widths={{ label: 4, content: 8 }}
        targetKpi={targetKpi}
        targetKpiValue={targetKpiValue}
        onChange={onChange}
        readOnly
        showRecommendation={false}
        campaignObjective={campaignObjective}
      />
      <span> Proposal </span>
      <TargetKpi
        widths={{ label: 4, content: 8 }}
        targetKpi={value.targetKpi}
        targetKpiValue={value.targetKpiValue}
        onChange={onChange}
        readOnly={false}
        showRecommendation={false}
        campaignObjective={campaignObjective}
      />
    </>
  );
}

ChangeTargetForm.propTypes = {
  onChange: func.isRequired,
  campaign: campaignShape.isRequired,
  value: shape({
    targetKpi: string.isRequired,
    targetKpiValue: number.isRequired,
  }).isRequired,
};

export default ChangeTargetForm;
